import { useParams } from 'react-router'
import KpiSummary from '../stories/KpiSummary/KpiSummary'
import classes from './Matches.module.css'
import { useMatchStats } from './api'
import { Typography } from '../common/typography'
import clsx from 'clsx'
import { useMediaQuery } from '@mantine/hooks'
import MvpCard from './MvpCard'

export default function MatchSummary() {
  const { competitionId, matchId } = useParams()
  const isDesktop = useMediaQuery('(min-width: 800px)')

  const { data: matchStats } = useMatchStats({
    competition_id: Number(competitionId),
    match_id: Number(matchId),
  })

  return (
    <div
      className={clsx(classes.match_summary_container, {
        [classes.match_summary_container_mobile]: !isDesktop,
      })}
    >
      <div className={classes.match_summary_data}>
        {matchStats.kpi_stats.length > 0 ? (
          matchStats.kpi_stats.map((kpiStat) => (
            <KpiSummary
              key={kpiStat.metric_id}
              title={kpiStat.metric_name}
              home_team_percentage={kpiStat.home_team_percent * 100}
              home_team_score={kpiStat.home_team_score}
              away_team_percentage={kpiStat.away_team_percent * 100}
              away_team_score={kpiStat.away_team_score}
            />
          ))
        ) : (
          <div className={classes.withoutData}>
            <Typography
              fs="xs"
              fw={500}
              lh="130"
              fc={{ light: 'black', dark: 'gray-3' }}
            >
              No data to display at this moment.
            </Typography>
            <Typography
              fs="xs"
              fw={500}
              lh="130"
              fc={{ light: 'black', dark: 'gray-3' }}
            >
              Please visit this page later.
            </Typography>
          </div>
        )}
      </div>
      {matchStats.home_mvp_id != null && matchStats.away_mvp_id != null && (
        <div className={classes.mvpContainer}>
          <Typography fw={500} fc={{ light: 'black', dark: 'gray-3' }} lh="125">
            MVP
          </Typography>
          <div className={classes.mvpCards}>
            <MvpCard
              player_id={matchStats.home_mvp_id}
              competition_id={Number(competitionId)}
              isHomeMvp
              round_start={matchStats.round_start}
            />
            <MvpCard
              player_id={matchStats.away_mvp_id}
              competition_id={Number(competitionId)}
              isHomeMvp={false}
              round_start={matchStats.round_start}
            />
          </div>
        </div>
      )}
    </div>
  )
}
